'use client';

import { ENGLISH_IQ_EVENTS } from '@repo/analytics';
import type { IEnglishIqResult } from '@repo/sdk';
import { trackEvent } from '@repo/web-chrome/lib/analytics';
import type { Dispatch, SetStateAction } from 'react';
import { completeEnglishIqWebSession } from '../actions';
import { isEnglishIqTerminalSessionError } from './helper';

interface IUseEnglishIqFinishParams {
  clearSession: () => void;
  setError: Dispatch<SetStateAction<string | null>>;
  setIsBusy: Dispatch<SetStateAction<boolean>>;
  storeResult: (result: IEnglishIqResult) => void;
}

export function useEnglishIqFinish(params: IUseEnglishIqFinishParams) {
  return async (token?: string): Promise<void> => {
    if (!token) {
      return;
    }
    params.setIsBusy(true);
    params.setError(null);
    try {
      const completed = await completeEnglishIqWebSession(token);
      params.storeResult(completed);
      trackEvent(ENGLISH_IQ_EVENTS.testComplete, { score: completed.score, surface: 'web' });
      trackEvent(ENGLISH_IQ_EVENTS.resultViewed, { score: completed.score, surface: 'web' });
    } catch (error) {
      if (isEnglishIqTerminalSessionError(error)) {
        params.clearSession();
        params.setError('session');
      } else {
        params.setError('finish');
      }
    } finally {
      params.setIsBusy(false);
    }
  };
}
